import * as React from 'react'
import { AttachFileFilled, LightTooltip } from '@sales-center/components'
import { IconButtonStyled } from './IconButton.styled'
import { useSelector } from 'react-redux'
import { selectAllAttachments } from '@user/store/attachments'
import Badge from '@mui/material/Badge'

type Props = {
  onOpenAttachments: () => void
}

export function AttachmentsButton(props: Props) {
  const { onOpenAttachments } = props
  const attachments = useSelector(selectAllAttachments)

  return (
    <Badge color="primary" badgeContent={attachments.length} overlap="circular">
      <LightTooltip title="Attachments">
        <IconButtonStyled
          size="large"
          aria-describedby="popover"
          onClick={onOpenAttachments}
          data-test-id="attachmentsBtn"
        >
          <AttachFileFilled variant="medium" />
        </IconButtonStyled>
      </LightTooltip>
    </Badge>
  )
}
